/* Noemi Flowers — related products carousel: arrow buttons + scroll progress bar. */
if (!customElements.get('nf-related-carousel')) {
  customElements.define(
    'nf-related-carousel',
    class NfRelatedCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.nf-related__track');
        this.bar = this.querySelector('.nf-related__progress-bar');
        this.prev = this.querySelector('[data-dir="-1"]');
        this.next = this.querySelector('[data-dir="1"]');
        if (!this.track) return;
        this.onScroll = this.update.bind(this);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        [this.prev, this.next].forEach((btn) =>
          btn?.addEventListener('click', () => this.go(parseInt(btn.dataset.dir, 10)))
        );
        this.ro = new ResizeObserver(this.onScroll);
        this.ro.observe(this.track);
        this.update();
      }

      disconnectedCallback() {
        this.ro?.disconnect();
      }

      go(dir) {
        const slide = this.track.querySelector('.nf-related__slide');
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = slide ? slide.getBoundingClientRect().width + gap : this.track.clientWidth;
        const perPage = Math.max(1, Math.floor((this.track.clientWidth + gap) / step));
        this.track.scrollBy({ left: dir * step * perPage, behavior: 'smooth' });
      }

      update() {
        const { scrollLeft, scrollWidth, clientWidth } = this.track;
        const max = Math.max(0, scrollWidth - clientWidth);
        const scrollable = max > 2;
        this.classList.toggle('is-scrollable', scrollable);
        if (this.bar) {
          const ratio = scrollWidth ? clientWidth / scrollWidth : 1;
          const progress = max ? scrollLeft / max : 0;
          this.bar.style.width = `${Math.min(100, ratio * 100)}%`;
          this.bar.style.left = `${progress * (100 - Math.min(100, ratio * 100))}%`;
        }
        const media = this.track.querySelector('.card__inner');
        if (media) this.style.setProperty('--nf-arrow-top', `${media.offsetHeight / 2}px`);
        if (this.prev) this.prev.disabled = scrollLeft <= 2;
        if (this.next) this.next.disabled = scrollLeft >= max - 2;
      }
    }
  );
}
